import React from "react";
import "./IdentityVerification/dashboard.css";

const Loading = () => {
  return (
    <div class="loading style-2">
      <div class="loading-wheel"></div>
    </div>
  );
};

export default Loading;
